module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1pqsy"))).then(() => module.bundle.root('1xiSz'));